<template>
  <span>
    <v-dialog v-model="dialogLocal">
      <template v-slot:activator="{ on, attrs }">
        <v-icon size="18" class="mb-1 grey--text" v-bind="attrs" v-on="on">
          mdi-help-circle
        </v-icon>
      </template>

      <v-card>
        <v-card-title class="titulo">
          Tipos de Cálculos
        </v-card-title>

        <v-card-text class="subtitulo text-center">
          Esse parâmetro filtra os Tipos de Serviços (SERV_005) utilizados nos
          cálculos.
        </v-card-text>

        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="tableItems"
            :items-per-page="-1"
            dense
          >
            <template v-slot:[`item.indicador`]="{ item }">
              <v-tooltip
                bottom
                v-if="traducaoIndicadores[item.indicador] != null"
              >
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{ item.text }}</span>
                </template>
                <span>{{ traducaoIndicadores[item.indicador] }}</span>
              </v-tooltip>
              <span v-else>{{ item.text }}</span>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogLocal = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
  import DashboardLnoService from "@/services/DashboardLnoService";

  export default {
    name: "DialogTiposCalculos",
    props: {
      dialog: {
        type: Boolean,
        default: false,
      },
      traducaoIndicadores: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        listaServicos: {},
        headers: [
          { text: "Indicador", value: "indicador" },
          { text: "LNO", value: "lno" },
          { text: "GD", value: "gdis" },
          { text: "LNO e GD", value: "lno_gdis" },
          { text: "Fórmula", value: "formula" },
        ],
        formulas: {
          qlp: "Serv_011 – serv_012",
          pla: "Serv_013 / (serv_011 – serv_012)",
          "pla+e": "Serv_013 / (serv_011 – serv_012)",
          pmea: "(Serv_013 * serv_014) / serv_013",
          pmea2: "(Serv_013 * serv_014) / serv_013",
          pmea15: "(Serv_013 * serv_014) / serv_013",
          pmea30: "(Serv_013 * serv_014) / serv_013",
          pmea45: "(Serv_013 * serv_014) / serv_013",
          pat1: "(Serv_013 * serv_014) / serv_013",
          pat2: "(Serv_013 * serv_014) / serv_013",
          pat3: "(Serv_013 * serv_014) / serv_013",
          pat4: "(Serv_013 * serv_014) / serv_013",
          loc_obras_urbano:
            "No prazo: serv_011 - serv_012; Em atraso: serv_013",
          loc_obras_rural: "No prazo: serv_011 - serv_012; Em atraso: serv_013",
          tipologia_solicitacoes_tipo_1:
            "No prazo: serv_011 - serv_012; Em atraso: serv_013",
          tipologia_solicitacoes_tipo_2:
            "No prazo: serv_011 - serv_012; Em atraso: serv_013",
          tipologia_solicitacoes_tipo_3:
            "No prazo: serv_011 - serv_012; Em atraso: serv_013",
          tipologia_solicitacoes_tipo_4:
            "No prazo: serv_011 - serv_012; Em atraso: serv_013",
          tipologia_solicitacoes_orcamento:
            "No prazo: serv_011 - serv_012; Em atraso: serv_013",
          obra_no_prazo: "(serv_011 - serv_013) - serv_012",
          orcamento_no_prazo: "(serv_011 - serv_013) - serv_012",
          obra_atrasada: "serv_013",
          orcamentos_atrasados: "serv_013",
          obra_suspensa: "serv_012",
          orcamentos_suspensos: "serv_012",
          psfp: "serv_008/serv_006",
          entrantes: "serv_010",
          concluidos: "serv_006",
        },
      };
    },
    computed: {
      dialogLocal: {
        get() {
          return this.dialog;
        },
        set(newValue) {
          this.$emit("update:dialog", newValue);
        },
      },
      tableItems() {
        const indicadores = [
          { value: "qlp", text: "QLP" },
          { value: "pla", text: "PLA" },
          { value: "pmea15", text: "PMEA15" },
          { value: "pmea30", text: "PMEA30" },
          { value: "pmea45", text: "PMEA45" },
          { value: "pat1", text: "PAT1" },
          { value: "pat2", text: "PAT2" },
          { value: "pat3", text: "PAT3" },
          { value: "pat4", text: "PAT4" },
          { value: "loc_obras_urbano", text: "Localização das Obras - Urbano" },
          { value: "loc_obras_rural", text: "Localização das Obras - Rural" },
          {
            value: "tipologia_solicitacoes_tipo_1",
            text: "Tipologias das Solicitações - Tipo 1",
          },
          {
            value: "tipologia_solicitacoes_tipo_2",
            text: "Tipologias das Solicitações - Tipo 2",
          },
          {
            value: "tipologia_solicitacoes_tipo_3",
            text: "Tipologias das Solicitações - Tipo 3",
          },
          {
            value: "tipologia_solicitacoes_tipo_4",
            text: "Tipologias das Solicitações - Tipo 4",
          },
          {
            value: "tipologia_solicitacoes_orcamento",
            text: "Tipologias das Solicitações - Orçamento",
          },
          { value: "obra_no_prazo", text: "Obra no Prazo" },
          { value: "obra_atrasada", text: "Obra Atrasada" },
          { value: "obra_suspensa", text: "Obra Suspensa" },
          { value: "orcamento_no_prazo", text: "Orçamento no Prazo" },
          { value: "orcamentos_atrasados", text: "Orçamentos Atrasados" },
          { value: "orcamentos_suspensos", text: "Orçamentos Suspensos" },
          { value: "psfp", text: "PSFP" },
          { value: "entrantes", text: "Entrantes" },
          { value: "concluidos", text: "Concluídos" },
        ];

        let items = indicadores.map((el) => ({
          indicador: el.value,
          text: el.text,
          formula: this.formulas[el.value] || "-",
          lno: this.listaServicos?.lno?.[el.value]?.join(", ") || "-",
          gdis: this.listaServicos?.gdis?.[el.value]?.join(", ") || "-",
          lno_gdis: this.listaServicos?.lno_gdis?.[el.value]?.join(", ") || "-",
        }));

        return items;
      },
    },
    created() {
      this.getListaServicosByTipoCalculo();
    },
    methods: {
      getListaServicosByTipoCalculo() {
        return DashboardLnoService.getListaServicosByTipoCalculo()
          .then((response) => {
            this.listaServicos = response;
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
  };
</script>

<style>
  .titulo {
    font-family: 'styrene A' !important;
    font-weight: 500 !important;
    color: #3c4858 !important;
    font-size: 18px !important;
  }

  .subtitulo {
    font-family: 'styrene A' !important;
    color: #3c4858 !important;
    font-size: 14px !important;
    font-weight: 300 !important;
  }
</style>
